export default {"src":"/_next/static/media/sort.c9646e27.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};